import apiClient from 'ps-components/lib/apiClient';
import { getCSRFPair } from 'ps-components/redux/stateSelectors';
import addAlert from 'ps-components/AlertToast/addAlert';

export const ADD_SURVEY_JOB_MATCH = 'ADD_SURVEY_JOB_MATCH',
  ADD_SURVEY_JOB_MATCH_START = ADD_SURVEY_JOB_MATCH + '_START',
  ADD_SURVEY_JOB_MATCH_SUCCESS = ADD_SURVEY_JOB_MATCH + '_SUCCESS',
  ADD_SURVEY_JOB_MATCH_FAILURE = ADD_SURVEY_JOB_MATCH + '_FAILURE',
  DATA_REFETCHED = 'DATA_REFETCHED',
  DELETE_JOB_MATCH_FAILED = 'DELETE_JOB_MATCH_FAILED',
  DELETE_JOB_MATCH_START = 'DELETE_JOB_MATCH_START',
  DELETE_JOB_MATCH_SUCCESS = 'DELETE_JOB_MATCH_SUCCESS',
  SET_MARKET_PRICING_DISPLAY_IN = 'SET_MARKET_PRICING_DISPLAY_IN',
  COPY_JOB_MATCHES_START = 'COPY_JOB_MATCHES_START',
  COPY_JOB_MATCHES_SUCCESS = 'COPY_JOB_MATCHES_SUCSESS',
  COPY_JOB_MATCHES_FAILED = 'COPY_JOB_MATCHES_FAILED',
  RESET_MARKET_PRICING_REPORT_OPTION = 'RESET_MARKET_PRICING_REPORT_OPTION',
  SET_MARKET_PRICING_REPORT_OPTION = 'SET_MARKET_PRICING_REPORT_OPTION';

export const GET_SURVEY_VIEWS_START = 'GET_SURVEY_VIEWS_START';
export const GET_SURVEY_VIEWS_SUCCESS = 'GET_SURVEY_VIEWS_SUCCESS';
export const GET_SURVEY_VIEWS_ERROR = 'GET_SURVEY_VIEWS_ERROR';

export const GET_SURVEY_SELECTED_VIEW_START = 'GET_SURVEY_SELECTED_VIEW_START';
export const GET_SURVEY_SELECTED_VIEW_SUCCESS = 'GET_SURVEY_SELECTED_VIEW_SUCCESS';
export const GET_SURVEY_SELECTED_VIEW_ERROR = 'GET_SURVEY_SELECTED_VIEW_ERROR';

export const SET_SURVEY_SELECTED_VIEW_START = 'SET_SURVEY_SELECTED_VIEW_START';
export const SET_SURVEY_SELECTED_VIEW_SUCCESS = 'SET_SURVEY_SELECTED_VIEW_SUCCESS';
export const SET_SURVEY_SELECTED_VIEW_ERROR = 'SET_SURVEY_SELECTED_VIEW_ERROR';

export const UPLOAD_JOB_DESCRIPTION_START = 'UPLOAD_JOB_DESCRIPTION_START';
export const UPLOAD_JOB_DESCRIPTION_SUCCESS = 'UPLOAD_JOB_DESCRIPTION_SUCCESS';
export const UPLOAD_JOB_DESCRIPTION_ERROR = 'UPLOAD_JOB_DESCRIPTION_ERROR';

export const DELETE_JOB_DESCRIPTION_START = 'DELETE_JOB_DESCRIPTION_START';
export const DELETE_JOB_DESCRIPTION_SUCCESS = 'DELETE_JOB_DESCRIPTION_SUCCESS';
export const DELETE_JOB_DESCRIPTION_ERROR = 'DELETE_JOB_DESCRIPTION_ERROR';

export const DOWNLOAD_JOB_DESCRIPTION_START = 'DOWNLOAD_JOB_DESCRIPTION_START';
export const DOWNLOAD_JOB_DESCRIPTION_SUCCESS = 'DOWNLOAD_JOB_DESCRIPTION_SUCCESS';
export const DOWNLOAD_JOB_DESCRIPTION_ERROR = 'DOWNLOAD_JOB_DESCRIPTION_ERROR';

export const CHANGE_STATUS_START = 'CHANGE_STATUS_START';
export const CHANGE_STATUS_SUCCESS = 'CHANGE_STATUS_SUCCESS';
export const CHANGE_STATUS_ERROR = 'CHANGE_STATUS_ERROR';

export const RESET_JOB_DESCRIPTION = 'RESET_JOB_DESCRIPTION';
export const SET_JOB_DESCRIPTION_ERROR = 'SET_JOB_DESCRIPTION_ERROR';

export const APPLY_WEIGHTING_START = 'APPLY_WEIGHTING_START';
export const APPLY_WEIGHTING_SUCCESS = 'APPLY_WEIGHTING_SUCCESS';
export const APPLY_WEIGHTING_ERROR = 'APPLY_WEIGHTING_ERROR';
export const APPLY_WEIGHTING_RESET = 'APPLY_WEIGHTING_RESET';
export const APPLY_WEIGHTING_COUNTS = 'APPLY_WEIGHTING_COUNTS';

export const DELETE_VIEW_START = 'DELETE_VIEW_START';
export const DELETE_VIEW_SUCCESS = 'DELETE_VIEW_SUCCESS';
export const DELETE_VIEW_ERROR = 'DELETE_VIEW_ERROR';

export const MOVE_VIEW_START = 'MOVE_VIEW_START';
export const MOVE_VIEW_SUCCESS = 'MOVE_VIEW_SUCCESS';
export const MOVE_VIEW_ERROR = 'MOVE_VIEW_ERROR';

export const GET_ELEMENT_TREE_START = 'GET_ELEMENT_TREE_START';
export const GET_ELEMENT_TREE_SUCCESS = 'GET_ELEMENT_TREE_SUCCESS';
export const GET_ELEMENT_TREE_ERROR = 'GET_ELEMENT_TREE_ERROR';
export const GET_ELEMENT_TREE_RESET = 'GET_ELEMENT_TREE_RESET';

export const SAVE_VIEW_START = 'SAVE_VIEW_START';
export const SAVE_VIEW_SUCCESS = 'SAVE_VIEW_SUCCESS';
export const SAVE_VIEW_ERROR = 'SAVE_VIEW_ERROR';

export const SET_DEFAULT_VIEW_START = 'SET_DEFAULT_VIEW_START';
export const SET_DEFAULT_VIEW_SUCCESS = 'SET_DEFAULT_VIEW_SUCCESS';
export const SET_DEFAULT_VIEW_ERROR = 'SET_DEFAULT_VIEW_ERROR';

const SURVEY_PAGE_NAME = 'search_matches';

export function resetApplyWeighting() {
  return { type: APPLY_WEIGHTING_RESET };
}

export function getApplyWeightingCounts() {
  return async dispatch => {
    try {
      const result = await apiClient.apiPost('/api/market-pricing/weighting/reweightCounts');

      if (result.data.success) {
        dispatch({
          type: APPLY_WEIGHTING_COUNTS,
          countWithZero: result.data.countWithZero,
          countWithoutZero: result.data.countWithoutZero
        });
      } else {
        throw Error('Error getting reweight counts');
      }
    } catch (error) {
      console.error(error);
    }
  };
}

export function applyWeighting(weighting, updateZero) {
  return async dispatch => {
    const errorMessage = 'Error applying weight to all matches';

    try {
      dispatch({ type: APPLY_WEIGHTING_START });
      const result = await apiClient.apiPost('/api/market-pricing/weighting/reweight', {
        weighting,
        updateZero
      });

      if (result.data.success) {
        dispatch({ type: APPLY_WEIGHTING_SUCCESS });
      } else {
        throw Error('Error applying default weight to all matches');
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');

      dispatch({ type: APPLY_WEIGHTING_ERROR, error: errorMessage });
      console.error(error);
    }
  };
}

export function changeStatus(status, job, benchmarkYear) {
  return async dispatch => {
    const errorMessage = 'Error updating status';

    try {
      dispatch({ type: CHANGE_STATUS_START });
      const result = await apiClient.apiPost('/api/market-pricing/job-matches/updateSlotP', {
        benchmarkYear,
        orgJobId: job.id,
        orgJobCode: job.code,
        orgJobCodeKey: job.codeKey,
        status
      });

      if (result.data.success) {
        dispatch({ type: CHANGE_STATUS_SUCCESS });

        return null;
      } else if (!result.data.success && result.data.usedJobs?.length > 0) {
        dispatch({ type: CHANGE_STATUS_SUCCESS });

        return result.data.usedJobs;
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');

      dispatch({ type: CHANGE_STATUS_ERROR, error: errorMessage });
      console.error(error);

      return null;
    }
  };
}

export function addMatch(
  orgJobId,
  cutId,
  feedback,
  isSelectAll = false,
  benchmarkYear,
  slottedInfo,
  isSlideout = false
) {
  return async (dispatch, getState) => {
    const successMessage = `Successfully added ${isSelectAll ? 'matches' : 'match'} to pricing`;
    const errorMessage = `Error adding ${isSelectAll ? 'matches' : 'match'} to pricing`;
    const summariesUpdateWarning = 'Error updating overall composite after adding match';

    const state = getState();
    const selectedAgingFactor = state?.marketPricing?.JobPricingReducer?.MainJobPricingReducer?.selectedAgingFactor;

    try {
      dispatch({
        type: ADD_SURVEY_JOB_MATCH_START,
        id: isSelectAll ? 'all' : cutId || slottedInfo?.slottedOrgJobId
      });

      const result = await apiClient.apiGet('/api/market-pricing/job-matches/addMatch', {
        params: {
          org_job_id: orgJobId,
          cut_id: cutId,
          benchmarkYear,
          slottedOrgJobId: slottedInfo ? slottedInfo.slottedOrgJobId : undefined,
          slottedOrgJobCode: slottedInfo ? slottedInfo.slottedOrgJobCode : undefined,
          slottedOrgJobCodeKey: slottedInfo ? slottedInfo.slottedOrgJobCodeKey || ' ' : undefined,
          slottedAgingCode: slottedInfo ? slottedInfo.slottedAgingCode : 'default',
          aging_code: selectedAgingFactor
        }
      });

      if (!result.data.success) {
        dispatch({ type: ADD_SURVEY_JOB_MATCH_FAILURE });

        throw Error('Error adding match to pricing');
      } else if (result.data.success || result.status === 200) {
        if (feedback) {
          apiClient.apiPost('/api/recommender/marketplace-matches/feedback', { ...feedback });
        }

        if (result.data.errorUpdatingMatches) {
          addAlert(summariesUpdateWarning, 'warning');
          console.warn('Error updating overall composite: ', result.data.errorUpdatingMatches);
        } else {
          addAlert(successMessage, 'success');
        }

        dispatch({
          type: ADD_SURVEY_JOB_MATCH_SUCCESS,
          payload: { ...result.data, refetchData: isSlideout ? true : false }
        });
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      dispatch({ type: ADD_SURVEY_JOB_MATCH_FAILURE });
      console.error(error);

      throw error;
    }
  };
}

export function deleteMatch(
  orgJobId,
  cutIds,
  matchIds,
  benchmarkYear,
  isSelectAll = false,
  slottedInfo,
  isSlideout = false
) {
  return async dispatch => {
    const successMessage = `Successfully removed ${isSelectAll ? 'matches' : 'match'} from pricing`;
    const errorMessage = `Error removing ${isSelectAll ? 'matches' : 'match'} from pricing`;
    const summariesUpdateWarning = 'Error updating overall composite after removing match';

    try {
      dispatch({
        type: DELETE_JOB_MATCH_START,
        id: isSelectAll ? 'all' : cutIds?.length > 0 ? cutIds[0] : slottedInfo?.slottedOrgJobId
      });

      const result = await apiClient.apiDelete('/api/market-pricing/job-matches/removeMatch', {
        data: {
          org_job_id: orgJobId,
          remove_cut: slottedInfo ? undefined : cutIds || [],
          remove_match: matchIds || [],
          benchmarkYear,
          slottedOrgJobId: slottedInfo ? slottedInfo.slottedOrgJobId : undefined,
          slottedOrgJobCode: slottedInfo ? slottedInfo.slottedOrgJobCode : undefined,
          slottedOrgJobCodeKey: slottedInfo ? slottedInfo.slottedOrgJobCodeKey || ' ' : undefined
        }
      });
      if (result.data.success) {
        dispatch({ type: DELETE_JOB_MATCH_SUCCESS, payload: { refetchData: isSlideout ? true : false } });

        if (result.data.errorUpdatingMatches) {
          addAlert(summariesUpdateWarning, 'warning');
          console.warn('Error updating overall composite: ', result.data.errorUpdatingMatches);
        } else {
          addAlert(successMessage, 'success');
        }
      } else {
        dispatch({ type: DELETE_JOB_MATCH_FAILED });

        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      dispatch({ type: DELETE_JOB_MATCH_FAILED });
      console.error(error);

      throw error;
    }
  };
}

export const dataRefetched = () => ({ type: DATA_REFETCHED });

export function setDisplayIn(displayIn) {
  return { type: SET_MARKET_PRICING_DISPLAY_IN, displayIn };
}

export function setReportDropdown(option) {
  return { type: SET_MARKET_PRICING_REPORT_OPTION, option };
}

export function resetReportDropdown() {
  return { type: RESET_MARKET_PRICING_REPORT_OPTION };
}

export function copyJobMatches(sourceOrgJobId, destinationOrgJobId, cutIds, benchmarkYear, isSelectAll = false) {
  return async (dispatch, getState) => {
    dispatch({ type: COPY_JOB_MATCHES_START, id: isSelectAll ? 'all' : cutIds[0] });

    const successMessage = `Successfully copied ${isSelectAll ? 'matches' : 'match'} to pricing`;
    const errorMessage = `Error copying ${isSelectAll ? 'matches' : 'match'} to pricing`;
    const summariesUpdateWarning = `Error updating overall composite after copying ${
      isSelectAll ? 'matches' : 'match'
    }`;
    const state = getState();
    const selectedAgingFactor = state?.marketPricing?.JobPricingReducer?.MainJobPricingReducer?.selectedAgingFactor;

    try {
      const result = await apiClient.apiPost('/api/market-pricing/job-matches/copyJobMatches', {
        source_org_job_id: sourceOrgJobId,
        org_job_id: destinationOrgJobId,
        cutIds,
        retainCurrentMatches: true,
        survey_year: benchmarkYear,
        copyPayScalePublisher: true,
        aging_code: selectedAgingFactor
      });
      if (result.data.success) {
        if (result.data.errorUpdatingMatches) {
          addAlert(summariesUpdateWarning, 'warning');
          console.warn('Error updating overall composite: ', result.data.errorUpdatingMatches);
        } else {
          addAlert(successMessage, 'success');
        }

        dispatch({ type: COPY_JOB_MATCHES_SUCCESS });

        return result.data;
      }

      throw Error(errorMessage);
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.error(error);
      dispatch({ type: COPY_JOB_MATCHES_FAILED });

      throw error;
    }
  };
}

export function getSurveyViews(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving survey views';

    try {
      dispatch({ type: GET_SURVEY_VIEWS_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views`, {
        params: {
          contextName: SURVEY_PAGE_NAME,
          portAll: true,
          isFacet: false
        }
      });

      if (result.status < 300) {
        dispatch({
          type: GET_SURVEY_VIEWS_SUCCESS,
          views: result.data?.data?.views,
          defaultViewId: result.data?.data?.defaultViewId
        });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.error('Error in getSurveyViews: ', error);
      dispatch({ type: GET_SURVEY_VIEWS_ERROR });
    }
  };
}

export function getSelectedSurveyView(masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error retrieving selected survey view';

    try {
      dispatch({ type: GET_SURVEY_SELECTED_VIEW_START });

      const result = await apiClient.apiGet(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        params: {
          contextName: SURVEY_PAGE_NAME
        }
      });

      if (result.status < 300) {
        dispatch({ type: GET_SURVEY_SELECTED_VIEW_SUCCESS, selectedViewPk: result.data?.data?.view_pk });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.error('Error in getSelectedSurveyView: ', error);
      dispatch({ type: GET_SURVEY_SELECTED_VIEW_ERROR });
    }
  };
}

export function setSelectedSurveyView(viewPk, masterAccountId) {
  return async dispatch => {
    const errorMessage = 'Error setting selected survey view';

    try {
      dispatch({ type: SET_SURVEY_SELECTED_VIEW_START });

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/last-viewed`, {
        contextName: SURVEY_PAGE_NAME,
        viewId: viewPk
      });

      if (result.status < 300) {
        dispatch({ type: SET_SURVEY_SELECTED_VIEW_SUCCESS, selectedViewPk: viewPk });
      } else {
        throw Error(errorMessage);
      }
    } catch (error) {
      addAlert(errorMessage, 'danger');
      console.error('Error in setSelectedSurveyView: ', error);
      dispatch({ type: SET_SURVEY_SELECTED_VIEW_ERROR });
    }
  };
}

export function uploadJobDescription(file, orgJobId) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RESET_JOB_DESCRIPTION });
      dispatch({ type: UPLOAD_JOB_DESCRIPTION_START });

      const csrfPair = getCSRFPair(getState());
      const formData = new FormData();
      formData.append('orgJobId', orgJobId);
      formData.append('theFile', file);
      formData.append('csrf_timestamp', csrfPair.csrf_timestamp);
      formData.append('csrf_token', csrfPair.csrf_token);

      const result = await apiClient.apiPost(`/api/hris/uploads/jobUpload`, formData);

      if (result.data.success) {
        dispatch({ type: UPLOAD_JOB_DESCRIPTION_SUCCESS });
        this.downloadJobDescription({ id: orgJobId });
      } else {
        dispatch({ type: UPLOAD_JOB_DESCRIPTION_ERROR, error: 'Error uploading job description' });
      }
    } catch (error) {
      console.error('Error uploading job description: ', error);
      dispatch({ type: UPLOAD_JOB_DESCRIPTION_ERROR, error: 'Error uploading job description' });
    }
  };
}

async function downloadHRTMSJD(code) {
  return await apiClient.apiGet('/api/hris/uploads/getHrtmsJD', { params: { jobCode: code, download: false } });
}

async function downloadJD(id) {
  return await apiClient.apiGet('/api/hris/job-details/getJobDescription', { params: { orgJobId: id } });
}

export function downloadJobDescription(orgJob) {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: RESET_JOB_DESCRIPTION });
      dispatch({ type: DOWNLOAD_JOB_DESCRIPTION_START });

      if (!orgJob) {
        return;
      }

      const { code, id } = orgJob;
      const state = getState();
      const { accountMetaData, organization } = state.session;
      const { enableHRTMSIntegration, hrtmsEntityId, hrtmsUrl } = accountMetaData;
      const subsite = organization?.code;
      const isJdxEnabledAndConfigured = enableHRTMSIntegration && hrtmsEntityId && hrtmsUrl;

      const csrfPair = getCSRFPair(getState());
      const { csrf_timestamp, csrf_token } = csrfPair;

      let downloadURL = `/${subsite}/api/hris/job-details/downloadJobDescriptionFile?orgJobId=${id}&csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`,
        hasHRTMS = false,
        previewURL = `/${subsite}/app/views/jobs/${id}/file`;

      const defaultSuccessDispatchParams = {
        type: DOWNLOAD_JOB_DESCRIPTION_SUCCESS,
        fileType: 'pdf'
      };

      if (isJdxEnabledAndConfigured) {
        const hrtmsResult = await downloadHRTMSJD(code);
        const wasHrtmsSuccessful = hrtmsResult?.data?.success || hrtmsResult?.status === 200;

        if (!wasHrtmsSuccessful) {
          const result = await downloadJD(id);
          const wasJDSuccessful = result?.data?.success && result?.data?.description;

          if (!wasJDSuccessful) {
            dispatch({
              type: DOWNLOAD_JOB_DESCRIPTION_ERROR,
              error: result?.data?.reason || 'No Job Description Found'
            });
          } else {
            dispatch({ ...defaultSuccessDispatchParams, downloadURL, previewURL, hasHRTMS });
          }
        } else {
          downloadURL = `/${subsite}/api/hris/uploads/getHrtmsJD?jobCode=${code}&download=true&csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`;
          previewURL = `/${subsite}/api/hris/uploads/getHrtmsJD?jobCode=${code}&download=false&csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`;
          hasHRTMS = true;

          dispatch({ ...defaultSuccessDispatchParams, downloadURL, previewURL, hasHRTMS });
        }
      } else {
        const result = await downloadJD(id);
        const wasJDSuccessful = result?.data?.success && result?.data?.description;

        if (!wasJDSuccessful) {
          dispatch({ type: DOWNLOAD_JOB_DESCRIPTION_ERROR, error: result?.data?.reason || 'No Job Description Found' });
        } else {
          dispatch({ ...defaultSuccessDispatchParams, downloadURL, previewURL, hasHRTMS });
        }
      }
    } catch (error) {
      console.error(error);
      dispatch({ type: DOWNLOAD_JOB_DESCRIPTION_ERROR, error });
    }
  };
}

export function deleteJobDescription(orgJobId) {
  return async dispatch => {
    try {
      dispatch({ type: RESET_JOB_DESCRIPTION });
      dispatch({ type: DELETE_JOB_DESCRIPTION_START });

      const result = await apiClient.apiPost(`/api/hris/job-details/deleteJobDescription`, {
        orgJobId
      });
      if (result.data.success || result.success || result.status === 200) {
        dispatch({ type: DELETE_JOB_DESCRIPTION_SUCCESS });
      } else {
        dispatch({ type: DELETE_JOB_DESCRIPTION_ERROR, error: 'Error deleting Job Description' });
      }
    } catch (error) {
      console.error('Error deleting Job Description: ', error);
      dispatch({ type: DELETE_JOB_DESCRIPTION_ERROR, error: 'Error deleting Job Description' });
    }
  };
}

export function deleteConfigureView(viewPk, old_view_pk, masterAccountId) {
  return async (dispatch, getState) => {
    const errorMessage = 'Error removing view';
    const successMessage = 'Successfully deleted view';

    try {
      dispatch({ type: DELETE_VIEW_START });

      if (old_view_pk) {
        await apiClient.apiGet(
          '/page-config2/view-delete',
          {
            params: {
              view_pk: old_view_pk
            }
          },
          { useMerit: true }
        );
      }

      await apiClient.apiDelete(`/cms/api/accounts/${masterAccountId}/views/${viewPk}`);

      dispatch({ type: DELETE_VIEW_SUCCESS });
      addAlert(successMessage, 'success', 3000, 'top-right');
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
      console.error(error);
      dispatch({ type: DELETE_VIEW_ERROR });
    }
  };
}

export function setAsDefault(viewPk, pageCode, maid) {
  return async (dispatch, getState) => {
    const errorMessage = 'Error setting view as default';
    const successMessage = 'Successfully set view as default';

    try {
      dispatch({ type: SET_DEFAULT_VIEW_START });

      await apiClient.apiPost(`/cms/api/accounts/${maid}/views/set-default`, {
        viewId: viewPk,
        pageCode
      });

      dispatch({ type: SET_DEFAULT_VIEW_SUCCESS });
      addAlert(successMessage, 'success', 3000, 'top-right');
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
      console.error(error);
      dispatch({ type: SET_DEFAULT_VIEW_ERROR });
    }
  };
}

export function moveConfigureView(viewPk, newScope, masterAccountId) {
  return async (dispatch, getState) => {
    const errorMessage = 'Error moving view to a different type';
    const successMessage = `Successfully moved view to ${newScope}`;

    try {
      dispatch({ type: MOVE_VIEW_START });

      const result = await apiClient.apiPost(`/cms/api/accounts/${masterAccountId}/views/move`, {
        viewId: viewPk,
        scope: newScope
      });

      dispatch({ type: MOVE_VIEW_SUCCESS });
      addAlert(successMessage, 'success', 3000, 'top-right');
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
      console.error(error);
      dispatch({ type: MOVE_VIEW_ERROR });
    }
  };
}

export function getElementTree(maid, categoryCode, data) {
  return async (dispatch, getState) => {
    const errorMessage = `Error retrieving elements list for ${categoryCode}`;

    try {
      dispatch({ type: GET_ELEMENT_TREE_START });

      const { reportPk, reportElements, analyticsAggMode, convertAllToSlotted } = data;

      const result = await apiClient.apiGet(`/cms/api/accounts/${maid}/element-tree`, {
        params: {
          categoryCode,
          reportPk,
          reportElements,
          analyticsAggMode,
          convertAllToSlotted
        }
      });

      dispatch({
        type: GET_ELEMENT_TREE_SUCCESS,
        elementTree: result?.data?.data?.tree,
        defaultFields: result?.data?.data?.defaultFields,
        currentFields: result?.data?.data?.currentFields
      });
    } catch (error) {
      addAlert(errorMessage, 'danger', 5000, 'top-right');
      console.error(error);
      dispatch({ type: GET_ELEMENT_TREE_ERROR });
    }
  };
}

export function getElementTreeReset() {
  return { type: 'GET_ELEMENT_TREE_RESET' };
}

export function saveView(maid, elements, params) {
  return async (dispatch, getState) => {
    const isCreate = params.reportPk == null;
    const successMessage = isCreate ? 'Successfully created view' : 'Successfully updated view';
    const errorMessage = isCreate ? 'Error creating view' : 'Error updating view';
    const emptyWarningMessage = 'No elements selected';
    const duplicateWarningMessage = 'Duplicate view name';

    if (elements.length === 0) {
      addAlert(emptyWarningMessage, 'warning', 3000, 'top-right');

      return false;
    }

    try {
      dispatch({ type: SAVE_VIEW_START });

      const saveOptions = {
        elements: cleanElements(elements),
        viewName: params.viewName,
        viewDescription: params.viewDescription,
        scope: params.scope,
        isDefault: params.isDefault,
        page: params.page,
        pageCode: params.pageCode,
        report_pk: params.isCopy ? undefined : params.reportPk || undefined,
        view_pk: params.isCopy ? undefined : params.viewPk || undefined,
        categoryCode: params.categoryCode,
        includeAggregates: params.includeAggregates
      };

      await apiClient.apiPost(`/cms/api/accounts/${maid}/views/save`, saveOptions);

      dispatch({ type: SAVE_VIEW_SUCCESS });
      addAlert(successMessage, 'success', 3000, 'top-right');

      return true;
    } catch (error) {
      console.error(error);
      if (error?.response?.status === 408) {
        addAlert(duplicateWarningMessage, 'warning', 3000, 'top-right');
      } else {
        addAlert(errorMessage, 'danger', 5000, 'top-right');
      }

      dispatch({ type: SAVE_VIEW_ERROR, error: error.message });

      return false;
    }
  };
}

// remove any null fields cause tsoa/typescript validation in cms will complain
// and change the column order based on index
function cleanElements(elements) {
  elements.forEach((element, index) => {
    for (let key in element) {
      const value = element[key];
      if (value == null) {
        delete element[key];
      }

      if (key === 'metadata' && value) {
        for (let metaKey in value) {
          const metaValue = value[metaKey];
          if (metaValue == null) {
            delete value[metaKey];
          }
        }
      }
    }

    element.column_order = index + 1;
  });

  return elements;
}

export function setJobDescriptionError(error) {
  return dispatch => {
    const errorMessage = error?.message || error || 'Server Error';

    dispatch({ type: SET_JOB_DESCRIPTION_ERROR, error: errorMessage });
  };
}

export function resetJobDescription() {
  return dispatch => {
    dispatch({ type: RESET_JOB_DESCRIPTION });
  };
}
